export default function(h, row, index) {
    if (!row.record)
        return null
    return  <span><a href={row.record} target="_blank"><i class="icon-social-youtube"></i></a></span>
}